import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
//import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";


declare var ko: any;

export class platformStatsFbPagePost_template extends vnTemplate{

    //public validationsList: validationsList_template;
    //public filterDate: filterDate_template;

    protected getTemplateHtml(): string{
        return `

          
           <div class="sub-header w-justify" >

                <div class="w-left">
                    <div class="form-check-inline">                  
                        <input type="checkbox" id="facebookPage">
                        <label for="facebookPage" class="form-label icon i-check">FB page</label>   
                     </div>
                     <div class="form-check-inline">                  
                        <input type="checkbox" id="postType">
                        <label for="postType" class="form-label icon i-check">Type of post</label>   
                     </div>
                </div>
                <div class="w-center">
                    date picker
                </div>
                <div class="w-right">Type of Post checkbox</div>
                
            </div>
             
            <div class="list-header w-justify">
                <div class="w-left"></div>
                <div class="w-center"></div>
                <div class="w-right"></div>
            </div>
            
            
            
            <div class="w-list-results" id="list-results">
               
                <table class="list-results">
                    <thead>
                        <tr>
                            <th><span class="icon list-sort-none">Date of Publish</span></th>
                            <th><span class="icon list-sort-none">Page Title</span></th>
                            <th><span class="icon list-sort-none">Link to Facebook Post</span></th>
                            <th><span class="icon list-sort-none">Type of Post</span></th>
                            <th><span class="icon list-sort-none">Outbound Link Title</span></th>
                            <th><span class="icon list-sort-none">Outbound Link Clicks</span></th>
                            <th><span class="icon list-sort-none">Reach</span></th>
                            <th><span class="icon list-sort-none">CTR%</span></th>
                            <th><span class="icon list-sort-none">Reactions Count</span></th>
                            <th><span class="icon list-sort-none">Shares</span></th>
                            <th><span class="icon list-sort-none">Comments</span></th>
                            <th><span class="icon list-sort-none">Hides</span></th>
                                         
                        </tr>
                    </thead>
                    <tbody >
    
                        <tr class="cursor">
                            
                            <td><span></span></td>
                            <td><span></span></td>
                            <td><span></span></td>
                            <td><span></span></td>
                            <td><span></span></td>
                            <td><span></span></td>
                            <td><span></span></td>
                            <td><span></span></td>
                            <td><span></span></td>
                            <td><span></span></td>
                            <td><span></span></td>
                            <td><span></span></td>
                            
                        </tr>
                        
                    </tbody>
                </table>
            </div>
           `;
    }

    protected getTemplateName(): string{
        return "platformStatsFbPagePost_template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected buildViewModel(): any{

        let huit_neuf_this = this;
        return  {
            stats: ko.observableArray([])
            ,brandIcons: ko.observableArray([])
            ,date: ko.observable("")
            ,isLoading: ko.observable(0)
        };

    }

    public activateLoading(){

        this.getTemplateViewModel().isLoading(1);
    }

    public deactivateLoading(){

        this.getTemplateViewModel().isLoading(0);
    }

    public setStats(stats: Array<any>): void{

        this.getTemplateViewModel().stats(stats);
    }

    public setDate(data: string){


        this.getTemplateViewModel().date(data);
    }

    public setBrands(brands: Array<any>): void {

        let finalBrands = [];
        for(let b of brands) {

            finalBrands[b.id] = b.iconImage;
        }

        this.getTemplateViewModel().brandIcons(finalBrands);
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/platformStatsFbPagePost_template.ts